import React from "react";
import "./privacy_policy_page.css"
import Navbar from "./Navbar";
import FooterSection from "./footersection";
import PrivacyPolicyContent from "./privacy_policy_page_content";


const PrivacyPolicyPage =  () =>{
    return(
        <div>
                <Navbar hideNav={true}/>
                <PrivacyPolicyContent></PrivacyPolicyContent>
            <FooterSection/>
        </div>
    );
}

export default PrivacyPolicyPage;